import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subCriteriaSection", "criteriaTotalDisplay", "criteriaContainer"]
  static values = { type: String }

  connect() {
    this.updateCriteriaTotal = this.updateCriteriaTotal.bind(this)
    this.stripRequiredOnRemove = this.stripRequiredOnRemove.bind(this)
    if (this.hasCriteriaContainerTarget) {
      this.$criteriaContainer = window.jQuery(this.criteriaContainerTarget)
      this.$criteriaContainer.on("cocoon:after-insert", this.updateCriteriaTotal)
      this.$criteriaContainer.on("cocoon:before-remove", this.stripRequiredOnRemove)
      this.$criteriaContainer.on("cocoon:after-remove", this.updateCriteriaTotal)
    }
    if (this.hasSubCriteriaSectionTarget && this.subCriteriaSectionTarget.style.display === "none") {
      this.toggleRequiredInsideSection(false)
    }
    this.updateCriteriaTotal()
  }

  disconnect() {
    if (this.$criteriaContainer) {
      this.$criteriaContainer.off("cocoon:after-insert", this.updateCriteriaTotal)
      this.$criteriaContainer.off("cocoon:before-remove", this.stripRequiredOnRemove)
      this.$criteriaContainer.off("cocoon:after-remove", this.updateCriteriaTotal)
    }
  }

  focusNewSubCriteria() {
    if (!this.hasCriteriaContainerTarget) return
    // Defer to the next tick so cocoon has finished appending and the typeahead
    // destroy/re-init has finished rebuilding the input wrappers before we focus.
    setTimeout(() => {
      const inputs = this.criteriaContainerTarget.querySelectorAll(".quality-criteria-typeahead")
      const lastInput = inputs[inputs.length - 1]
      if (lastInput) lastInput.focus()
    }, 0)
  }

  stripRequiredOnRemove(event, $element) {
    const removed = ($element && $element[0]) || event.target
    if (removed && removed.classList) {
      removed.classList.add("job-quality-criterium-removed")
    }
    if (removed && removed.querySelectorAll) {
      removed.querySelectorAll("input[required]").forEach((input) => {
        input.removeAttribute("required")
      })
    }
    this.updateCriteriaTotal()
  }

  toggleSubCriteria(event) {
    if (!this.hasSubCriteriaSectionTarget) return
    const visible = event.target.checked
    this.subCriteriaSectionTarget.style.display = visible ? "" : "none"
    this.toggleRequiredInsideSection(visible)
  }

  toggleRequiredInsideSection(visible) {
    if (!this.hasSubCriteriaSectionTarget) return
    const inputs = this.subCriteriaSectionTarget.querySelectorAll("input")
    inputs.forEach((input) => {
      if (input.required && input.dataset.originalRequired === undefined) {
        input.dataset.originalRequired = "true"
      }
      if (input.dataset.originalRequired === "true") {
        if (visible) {
          input.setAttribute("required", "required")
        } else {
          input.removeAttribute("required")
        }
      }
    })
  }

  updateCriteriaTotal() {
    if (!this.hasCriteriaTotalDisplayTarget || !this.hasCriteriaContainerTarget) return

    const inputs = this.criteriaContainerTarget.querySelectorAll(".job-quality-criterium-weighting")
    const sum = Array.from(inputs)
      .filter((input) => !this.isMarkedForDestruction(input))
      .reduce((acc, input) => acc + (parseInt(input.value, 10) || 0), 0)

    const el = this.criteriaTotalDisplayTarget
    if (el.tagName === "INPUT") {
      el.value = sum
      const wrapper = el.closest(".form-group, .input-group")
      if (wrapper) wrapper.classList.toggle("has-error", sum !== 100)
    } else {
      const valueEl = el.querySelector(".award-criteria-group-criteria-total-value")
      if (valueEl) valueEl.textContent = sum
      el.classList.toggle("label-success", sum === 100)
      el.classList.toggle("label-danger", sum !== 100)
      const iconEl = el.querySelector(".award-criteria-group-criteria-total-icon")
      if (iconEl) {
        iconEl.classList.toggle("fa-check", sum === 100)
        iconEl.classList.toggle("fa-exclamation-circle", sum !== 100)
      }
    }
  }

  isMarkedForDestruction(input) {
    const wrapper = input.closest(".job-quality-criterium-fields")
    if (!wrapper) return false
    if (wrapper.classList.contains("job-quality-criterium-removed")) return true
    if (wrapper.style.display === "none") return true
    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    return destroyInput && (destroyInput.value === "1" || destroyInput.value === "true")
  }
}
